<template>
  <div class="embed-responsive embed-responsive-16by9">
    <video id="player" class="video-js embed-responsive-item" controls preload="auto">
    </video>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'
import videojs from 'video.js'
import Tech from 'videojs-flash'

export default {
  data(){
    return {
      player: null
    }
  },
  computed:{
    ...mapGetters('webcast', {
      webcast: 'getCopy'
    }),
    ...mapGetters('stream', {
      streamsInStore: 'find',
      getStreamInStore: 'get',
      stream: 'getCopy'
    }),
    ...mapGetters('appsettings', {
      appSettings: 'getCopy'
    }),
    playerUrl(){
      let playerUrl = this.appSettings.originServerUrl+'/'+this.stream.streamId;
      return playerUrl;
    }
  },
  watch:{
    stream(stream){
      if(stream){
        if(this.player){
          this.player.pause();
          this.player.src(this.playerUrl);
          this.player.load();
          this.player.play();
        } else {
          this.createPlayer();
        }
      }
    }
  },
  methods:{
    ...mapActions('stream', {
      findStreamsAction: 'find',
    }),
    createPlayer(){

      let self = this;
      setTimeout(()=>{
        videojs.options.flash.swf = "/video.js/dist/video-js.swf";

        this.player = videojs('player', {
            sources: [
              {
                src: this.playerUrl,
                type: 'rtmp/mp4'
              }
            ],
            "width": 640,
            "height": 360,
            'controls': true,
            'preload': 'auto',
            'liveui': 'true',
        }, function(){
          this.on("pause", function () {
            this.one("play", function () {
              this.load();
              this.play();
            });
          });
        });
      },100);
    }
  },
  created(){

  },
  destroyed(){
    if(this.player){
      this.player.dispose();
      this.player = null;
    }
  }
}
</script>


<style lang="scss">

</style>
